import './HomePage.css';
import HeroSection from './HeroSection';
import Capabilities from './Capabilities';
import ProductGallery from './ProductGallery';
import QuoteForm from './QuoteForm';

const HomePage = () => {
  return (
    <div className="home-page">
      <HeroSection />
      <Capabilities />
      <ProductGallery />
      <QuoteForm />
    </div>
  );
};

export default HomePage;